<template>
  <loading-spinner v-if="isLoading" />
  <div v-else>
    <div
      class="d-flex justify-content-between align-items-stretch shadow p-0 position-absolute w-100 pr-3"
    >
      <div class="dropdown" v-if="allCameras.length > 0 && camera">
        <button
          class="btn dropdown-toggle pl-4 pr-3 h-100 shadow border-right d-flex align-items-center justify-content-start"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <img
            class="mr-3 align-top"
            src="@/assets/ic_video.png"
            style="height: 1.5rem"
          />
          <div class="line-height-1 text-left">
            <span class="h5 mb-0 mr-3 text-nowrap font-weight-bold text-muted">
              {{ camera.name.split("_").join(" ") }}
            </span>
            <br /><small class="text-uppercase">{{ camera.type }}</small>
          </div>
        </button>
        <div
          class="dropdown-menu w-100 pt-0"
          aria-labelledby="dropdownMenuButton"
          style="max-height: 40vh; overflow-y: auto"
        >
          <template v-for="camera in allCameras">
            <h6
              class="dropdown-header pl-3 bg-secondary text-uppercase text-light font-weight-bold"
              :key="`headerCamera${camera.type}`"
            >
              {{ camera.type }}
            </h6>
            <router-link
              :to="{
                params: {
                  cameraId: cam.id,
                },
              }"
              class="dropdown-item"
              :class="{ active: cam.id == $route.params.cameraId }"
              :key="`buttonCamera${camera.type}-${cam.id}`"
              v-for="cam in camera.cameras"
            >
              {{ cam.name.split("_").join(" ") }}
            </router-link>
          </template>
        </div>
      </div>
      <div
        class="h5 px-4 shadow border-right mb-0 text-nowrap font-weight-bold text-muted d-flex justify-content-start align-items-center"
        v-else-if="camera"
      >
        <img class="mr-2" src="@/assets/ic_video.png" style="height: 1.5rem" />
        {{ camera.name.split("_").join(" ") }}
      </div>
      <div class="ml-auto">
        <button
          type="button"
          class="btn btn-close"
          aria-label="Close"
          @click="goBack()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="main-content">
      <div
        v-if="!camera"
        class="d-flex justify-content-center align-items-center px-3 py-5"
      >
        <h4 class="bg-light p-5 border shadow-sm text-center rounded">
          No camera
        </h4>
      </div>
      <template v-else></template>
      <div class="content-with-sidebar">
        <div class="left-side-list shadow">
          <div class="p-2 bg-black row mx-0">
            <div class="col px-0 clickable">
              <v-date-picker
                v-model="filter.date"
                class="v-calendar"
                :masks="{ input: 'YYYY-MM-DD' }"
                trim-weeks
                :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                :max-date="new Date()"
                :popover="{
                  visibility: 'focus',
                }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    class="form-control clickable user-select-none"
                    :value="inputValue"
                    v-on="inputEvents"
                    readonly
                  />
                  <i class="far fa-calendar-alt calendar-icon"></i>
                </template>
              </v-date-picker>
            </div>
          </div>
          <div class="detection-list-container" v-if="events.length > 0">
            <div
              class="detection-list list-item w-100 h-auto border-bottom d-flex p-3 align-items-center clickable"
              :class="{
                active: currentEvent && currentEvent.id == event.id,
              }"
              v-for="(event, index) in events"
              :key="`Event${event.id}`"
              @click="viewEvent(event)"
            >
              <div
                class="detection-image flex-grow-0 flex-shrink-0 shadow position-relative"
              >
                <img
                  :src="event.image.url"
                  v-if="event.image && event.image.url"
                  :data-annotated-image="
                    event.annotatedImage
                      ? event.annotatedImage.data[0].attributes.url
                      : null
                  "
                />
                <img src="@/assets/image_placeholder.png" alt="" v-else />
                <i
                  class="fas fa-check-circle text-success position-absolute bg-light rounded-circle"
                  style="top: 10px; left: 10px; font-size: 1.5rem"
                  v-if="event.isAddedToUauc"
                />
              </div>
              <div class="d-flex">
                <div
                  class="px-3 d-flex justify-content-center flex-column flex-grow-1 w-100"
                >
                  <p class="mb-1 font-weight-bold line-height-1">
                    <span class="font-weight-bold mr-1">#{{ index + 1 }}</span>
                    {{ event.name || "Person" }}
                  </p>
                  <p class="m-0">
                    <i class="fas fa-clock mr-2 text-primary"></i>
                    {{ formatDate(event.timestamp) }}
                  </p>
                  <p class="m-0">
                    <i class="fas fa-video mr-2 text-primary"></i>
                    {{ event.camera ? event.camera.name : "Undefined" }}
                  </p>
                </div>
                <div class="d-flex align-items-center flex-nowrap">
                  <button
                    class="btn btn-info"
                    @click="addToUAUC(event)"
                    v-if="
                      !event.isAddedToUauc &&
                      event.camera.type !== 'cctv' &&
                      currentEvent.id == event.id
                    "
                  >
                    <p class="m-0 font-weight-bold h6">+</p>
                  </button>
                </div>
              </div>
            </div>
            <div class="p-4 text-center text-muted font-italic">
              End of list
            </div>
          </div>
          <div class="p-4 text-center text-muted font-italic" v-else>
            No detection yet
          </div>
        </div>
        <div class="right-side-image home-image-container position-relative">
          <img
            v-if="currentEvent && currentEvent.image"
            :src="currentEvent.image.url"
            :class="{
              invisible:
                currentEvent && currentEvent.id == 'live' && camera.isError,
            }"
            @error="cameraIsOffline()"
          />
          <div
            class="live-icon shadow bg-danger"
            v-if="currentEvent && currentEvent.id == 'live'"
          >
            <i class="fas fa-broadcast-tower"></i>
            <span class="d-none d-md-inline-block ml-2">Live feed</span>
          </div>
          <button
            class="live-icon static shadow btn btn-primary bg-primary"
            @click="setLiveView()"
            v-else-if="currentEvent && currentEvent.id > 0"
          >
            <i class="fas fa-arrow-left mr-2"></i>
            Return to live feed
          </button>
          <div
            id="detection-settings"
            class="shadow"
            :class="{ shrink: shrinkDetectionType }"
            v-if="camera && ['lab', 'aisc'].includes(camera.type)"
          >
            <loading-spinner v-if="isSavingModel" />
            <div
              id="detection-settings-header"
              class="d-flex justify-content-between align-items-center"
            >
              <p
                class="font-weight-bold h5 user-no-select clickable"
                @click="toggleShrinkDetectionType()"
              >
                Menu
                <span class="ml-2 shrink-toggler">
                  <img src="@/assets/caret_down.png" style="height: 15px" />
                </span>
              </p>
            </div>
            <div class="row mx-0 mb-3" v-if="camera.type != 'cctv'">
              <div class="col-12 py-2 lead">
                <span class="badge badge-pill badge-info py-2 px-4">
                  CURRENT LOCATION
                </span>
              </div>
              <div class="col-sm-8 col-md-5 d-flex">
                <v-select
                  class="form-control p-0"
                  v-if="locations"
                  :options="locations"
                  label="name"
                  readonly
                  :disabled="!isEditingLocation"
                  v-model="model.currentLocation"
                />
                <button
                  class="btn btn-info btn-sm ml-3"
                  @click="isEditingLocation = true"
                  v-if="!isEditingLocation"
                >
                  <i class="fas fa-pencil-alt" />
                </button>
                <template v-else>
                  <button
                    class="btn btn-secondary btn-sm ml-3"
                    @click="
                      () => {
                        isEditingLocation = false;
                        model.currentLocation = camera.current_location;
                      }
                    "
                  >
                    <i class="fas fa-times" />
                  </button>
                  <button
                    class="btn btn-primary btn-sm ml-3"
                    @click="saveCurrentLocation()"
                  >
                    <i class="fas fa-save" />
                  </button>
                </template>
              </div>
            </div>
            <div class="row mx-0 mb-3" v-if="camera.type != 'cctv'">
              <div class="col-12 py-2 lead">
                <span class="badge badge-pill badge-info py-2 px-4">
                  CURRENT ACTIVITY
                </span>
              </div>
              <div class="col-sm-8 col-md-5 d-flex">
                <!-- <input
                  class="form-control"
                  v-model="model.currentLocation"
                  :disabled="!isEditingLocation"
                /> -->
                <!-- :reduce="(activity) => activity.name" -->
                <v-select
                  class="form-control p-0"
                  v-if="activities"
                  :options="activities"
                  label="name"
                  :disabled="!isEditingActivity"
                  v-model="model.currentActivity"
                />
                <button
                  class="btn btn-info btn-sm ml-3"
                  @click="isEditingActivity = true"
                  v-if="!isEditingActivity"
                >
                  <i class="fas fa-pencil-alt" />
                </button>
                <template v-else>
                  <button
                    class="btn btn-secondary btn-sm ml-3"
                    @click="
                      () => {
                        isEditingActivity = false;
                        model.currentActivity = camera.currentActivity;
                      }
                    "
                  >
                    <i class="fas fa-times" />
                  </button>
                  <button
                    class="btn btn-primary btn-sm ml-3"
                    @click="saveCurrentActivity()"
                  >
                    <i class="fas fa-save" />
                  </button>
                </template>
              </div>
            </div>
            <div class="row mx-0">
              <div
                class="col-12 py-2 lead d-flex justify-content-between align-items-center"
              >
                <span class="badge badge-pill badge-primary py-2 px-4">
                  DETECTION TYPES
                </span>
                <div
                  v-if="
                    camera.detections
                      .map((d) => d.id)
                      .sort()
                      .join(',') !=
                    JSON.parse(JSON.stringify(model.detections))
                      .sort()
                      .join(',')
                  "
                >
                  <button
                    class="btn btn-sm btn-light mr-2"
                    @click="resetDetections()"
                  >
                    Reset
                  </button>
                  <button
                    class="btn btn-sm btn-primary"
                    @click="saveDetections()"
                  >
                    Save
                  </button>
                </div>
              </div>
              <div
                class="col-6 col-md-4 py-2"
                v-for="detection in allDetections"
                :key="detection.id"
              >
                <div class="custom-control custom-checkbox user-select-none">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="`detection${detection.name}`"
                    :value="detection.id"
                    v-model="model.detections"
                    :disabled="
                      mandatoryDetections[camera.type] &&
                      mandatoryDetections[camera.type].includes(detection.name)
                    "
                  />
                  <label
                    class="custom-control-label font-weight-bold"
                    :class="
                      mandatoryDetections[camera.type] &&
                      mandatoryDetections[camera.type].includes(detection.name)
                        ? 'text-secondary'
                        : 'text-dark'
                    "
                    :for="`detection${detection.name}`"
                  >
                    {{ detection.displayName }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-u-a-u-c-modal
      :show="showUAUC"
      :event="selectedEvent"
      @close="closeUAUC"
      :activities="activities"
      :locations="locations"
    />

    <query-violation-modal
      :show="showQuery"
      :id="$route.query.violation"
      @close="closeQuery"
    />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Moment from "moment";
import LoadingSpinner from "../components/LoadingSpinner";
import Axios from "axios";
import AddUAUCModal from "../components/AddUAUCModal.vue";
import QueryViolationModal from '../components/QueryViolationModal.vue';
// import QueryViolationModal from '../components/QueryViolationModal.vue';

export default {
  components: { LoadingSpinner, AddUAUCModal, QueryViolationModal },
  name: "Detections",
  props: ["latestDetection"],
  data() {
    return {
      allCameras: [],
      allDetections: [],
      camera: null,
      showUAUC: false,
      events: [],
      currentEvent: null,
      isLoading: false,
      shrinkDetectionType: false,
      filter: {
        date: Moment().format("YYYY-MM-DD"),
      },
      model: {
        detections: [],
        currentLocation: null,
        currentActivity: null,
      },
      mandatoryDetections: {
        lab: ["no_white_coat", "no_yellow_jacket"],
      },
      isEditingLocation: false,
      isEditingActivity: false,
      isSavingModel: false,
      locations: null,
      activities: null,
      selectedEvent: null,
      showQuery: false,
      queryViolation: null
    };
  },
  watch: {
    latestDetection: {
      handler() {
        if (
          this.events.length > 0 &&
          this.latestDetection &&
          !this.isLoading &&
          Moment(this.latestDetection.createdAt).format("YYYY-MM-DD") ==
            this.filter.date &&
          (!this.$route.params.cameraId ||
            this.latestDetection.camera.id == this.$route.params.cameraId)
        ) {
          this.getEvents(this.latestDetection.id);
        }
      },
      immediate: true,
    },
    "filter.date": {
      handler() {
        this.isLoading = true;

        this.events = [];

        this.currentEvent = null;

        this.getEvents();
      },
    },

    "$route.params": {
      async handler() {
        this.isLoading = true;
        this.getLocations();
        this.getActivies();
        await this.getAllCameras();

        this.getAllDetections();

        if (this.$route.params.cameraId) {
          this.getCamera();
        } else if (this.allCameras.length > 0) {
          this.$router.replace({
            name: "Detections",
            params: {
              cameraId: this.allCameras.find((c) => c.type == "cctv").cameras[0]
                .id,
            },
          });
        }

      },
      deep: true,
      immediate: true,
    },

    
    "$route.query": {
      async handler() {
        console.log(this.$route.query.violation)
        if(this.$route.query.violation){
          console.log('this.$route.query.violation')
          this.queryViolation = this.$route.query.violation
        }
      },
      deep: true,
      immediate: true
    },

    queryViolation: {
      handler() {
        console.log('queryViolation',this.queryViolation);
        if(this.queryViolation != null){
          this.showQuery = true
        }
      },
      immediate: true
    }
  },
  methods: {
    addToUAUC(event) {
      this.selectedEvent = event;
      this.showUAUC = true;
    },
    closeQuery() {
      console.log('close query');
      this.queryViolation = null
      this.showQuery = false

      setTimeout(()=> {

        let params = {
          violation: null,
        };

        this.$router.replace({
          params: params,
        });
      }, 1500)
    },
    closeUAUC(e) {
      if (e) {
        const _event = this.events.find(
          (event) => event.id == this.selectedEvent.id
        );

        if (_event) {
          _event.isAddedToUauc = true;
        }
      }

      this.showUAUC = false;
      this.selectedEvent = null;
    },
    async getLocations() {
      const headers = {
        Accept: "application/json, text/plain, */*",
        "Accept-Language": "en-US,en;q=0.9,vi;q=0.8,id;q=0.7",
        Authorization:
          "Bearer JSb1aZxyxKpqq_rEgcIbGvjHnmRDD7VOcFncYFP5zGGZFHAfTwOdG9LWA0EezUoAaUp5P1bBn-AHcSS0cgm-oWP5M-1RB2bsO0C8r9oy68QsFh_nr1d2C7sM6c8a5bhxr0NWkmbPzJXdKdbUOZLOcxEkF6ZyBgVO3hleA4Oid4n-f8-SidkLRC-dBHCGXfVeZ-okWioX4_Fc0zvv-q300ISHZar_vzhN4h9_ZP2W2x4Qy4bb5n-tMY_Y0MybVr29t9UZycPG-WYKTmHCgEVEdh4-DpjaXlC5QmNmb7YV0siP9d9BOht180-MhkiI9MQmOv8aSG_ECOxSAaGVkY7rtE6vuQtEtyvMJT6B8qGQ_AzUN717IWZ7vcgiwxVoPHIL-6Yd2cv1_j7IYvh_Ux1y581poSSLW58fsOv94gM-wvKeqp37WPIb_rr5yrQch5AGUmnFS--W4enC-a-r40N5ig72VhkZskk6Eerjk-EM74_-GBSFXNL5p8CX-ZIGRS20BamkTLKEaIIKG7OvbiLTbaxKrNuaWKTybReBohbIV4nHjTJRE_JkMj1gB88T5_NgmZNUSk9eqE-p46ayxYeDKYHuYn0AE4jNla5Ldykp11ZQTOZ3sXKS8PMu4bKtZYG7xoFul7z5yXULeAu-6uB4Yp2KGHViw50Fi6jMMN_yZJ08E1HzQWBeawTifpxO2dVJB-A3vBO19_svjoy3Vb-CqyHPyZXNTwBMy7Rt4uKQqYekXIFgXFAaPlFHFSCIETHuB5qI1NU0erFnJnvgeQatvhuqTlI4dkTPUgUoFpkxQQhGqIhuD12IdztItrPrpL05YwMHnpU3aQ3toUuwIvq2Vz0F2vVwtNfi2SKrp-IktJ2F1-1238i0eeYZ3GIVhoVhvBA1k8vP4r7wCW-QfOYunJFr15XUzol4Js5oRu0TmkXOxlVu7oOFqAHLEg-nkfudWbGmgtthaElxEQ88hGwTnAB-9TahnmmOdLZ4b5qcYlwCMdh7qQFR4v717VZ0cSBPItcej2vbP1z2RjdmF0iYicv9Xhe0fifiydsj84vLXlUBQf9fOciBNLLuy77JaAR0Ba7z-_etM0lSNWqHkNy7S8oNjnEk7okFVxLYQLPpglInQGZOid4qv_9XCqFRPqo5CmNbmmn4F9-EiX6EP49p8kGK9uzuje6PkdCy-tlTtHr-7ABp8TEBzo9CSqseqwhDdXoOYtWniKqWUQCzwWY11KiJgkq6BUW59taXQo_Jqs_zoTElm8Fej40pUVaeM7lNh5pOxuI2CVxobFMPbD6lxP7G6-xGQASq3JXWZi1GZQcfvm9s38-WR7deRcJPtjkwZPoNFj1QDc7Zd1Cx4lbwR6KQBTsAPjXAuPUZQJPv4L5qx4wp_KZZsS0C3gWk8kdzHyoAtm7VhIfoQaRrGeF7I22bae-A8cF4tfC3G_zrjSlWoJWM7Zn-DlXMo-vVNnmytIjnGTR7WyMaWg0SzwO26S-8HG1FCxD7cb5_-oVCPXtmOklhcVGiAPleeyB54HmcDPyt5LyZ6Yk-mGwdnP0_R8ATJeeKirT5X6V9oiJW6BrC33M1xW8rESwyOcFWuTCCrToc5qANz49a8pFN8gWbvm7WzKz3TqZnnDW_gaXvzRDpiKaeR2yuOIYTgjvipaPKGEqSdmBr4PviV90F_eAsSLgFuvv-6a0yfPMT-Qs9MXf-YBetY1BUPRTdxhF9JwJEu7MNPClCYhsa6OUt7jQmIFDOJWOleGd73bW9T5BOwD9jU6WmmpZzVDNdxSkJ_8pSCRKjk1ctWrNUDepCFWXpNBEyN7Q7Xet8QLaqxz_g4FsNf7XCMKE4axh2yGkNuwNm4rXX193nfLzTlBDWzCzHXIjmiE4vHRH8rgEiSXh5xLoVHLnWKpKamTTgI17bXH518q-10OY0SkvUvXyOslk87piqQ9rxo_oO1cdi6B9JqfGnHRglwUfJMbJbAkyg4aOMxPEdrsMQqimliSl__gjDBJrQetbHg4qMMfxV9ZyaWDhAzLnwUUg_BDI4E8HJYIC_ckw6dTFv3DtITz9qIDadl6WTokX_kZpto_XLjxe-t2RtpJs4BZ0XolIHs7eIrJKKn77zWxMJ7chz1ZhXrQyEkESmULcUz5AaBEpDlKuy1sITp00oJPkwPV6HnBNFvxNzjb_V0kwtIUKYNKdT0FA4jTPZB6Vms34lI6t2XCeTO6QFH5vEIrXN9u2mnEFEZBWSDLcMUwmK8USbqpYrHUAV2LXs5PAWtK6bWyAEb-XzasJqh8WsCd34xDQaI49RfzUeF3dNOx5kHLC_dUC1fviSxUKu7he2UFfkRm5JidtNkI640p_qmPhr-c8C0anLF2H_MsFXXldDabVwF4_0zeCF_v4cSRQfWUtTnbFh79W0kp_h6TXHc4Xo_awUwyL2X9FDTdZ9evbiQxuCmbd4l5sKUmp12F_gIG_lWbxc87fLf-1eHNShH4TL3_uk85plUZNywqT1-PERW9aJCWHaumsfozJNAY4dEec4SsWoiN85XSAJ7LSFdz7qoYimaV4nuueqHK5-3WPJs4gd3mgsN3heIsx-i47_ckHjAgC9a4A7y9RPIPnawtfex4l8HbrMsy69t8cxWyeAz8rubly6h5fZKZWBEAsPrXs4ZBqh5440zdaCoVd5hWfqzUVkQFgO7IjaYCt8rjQZtfEhmrNIL9b9K2chhYJaoPQFyffImuxikzYVTfK06qWpMTgln-Isfo9YJhNpDIRCeD2NonzncjWa5_SODxmp293DrpZJImNAvYfTUaMcHbLCsaAmD5jKw7CJoMNY5fMr_4v6QufAVk9DAEXGSgPmlOHZFVhaNw6EioyqvPeQi4GcBvnLMDHNvELo7MCYiQTohVsWh99Xo0iD_8ABx-jZDbR2AZXyOAAkzvAL23XdrcMswzw7fDtgGdVzPK_JQ3BYDRelrc_8htkAcqup-FtTy9rE_KFi7MybH_IjEEGLofvsahV7uAVTijJIuVUNMTuk9CE89ILqSKeeIbADLUERMwlsoO-z5jHYkyLDh2t3gl_1Ufaj5degAL4VKVDhX2woOfH4L9V9csvLACSb9RdnaWbjEd8aWHHjRG0MsqW4i1zh3-PwMaDyFVsSyZxogJM_6mxRFsBthtWFJrowsjwAPPOGK0_RQvwRWFk6gUyj5kCezhj-ixnv1rcZziGCqQaG02waJLlO1WR5m7S5m3_g6Xl1dudnYpEml-0OEjRxAuUJ5-lLPKQCo2dAEjFJZUNgnqfcXUJeKKkJ-_siWqx1L0WuWJT7r8cRZsCT_LHu65wtc10Lm42wspMulygJCNlCPimKMzcuI_9iuy5RhawuKhVpdm-YAu0jXMBDLonhwdQ7ea3fTSxHypMTPQbf4ZO2GonxHCyhoZDSFdOeIQ02nV7t4yZLok9PGfuf6I13A6w163jTw4mRkfhOl-nrpP1CgHJwhiXI4iFMRQHyQhTbZazwDgalmPpMzvzTVIHCL9gpoUR_SNJehKxDSGzdiUIFmN3_7pKDTZtrDtDxuhNp4TGKg6Nq10JxWRAnRL6YUdu3kDGyhUgd-YSVszUmhzLHazvaq49fXWUQDTUeXC9FW873O5DtRF9_GnEptIKjmkAGdwO1-l3qRE4LH-RfsXhm4OFuupO6Nt1v9rPmZ0AUMcbp05YzMYCspD9LCMGRvubxFdXnug6rePbfJkM-W9eEe183AtXt9NevtQde60hBCKpukzgSVYBDiwnOgRYKxLg9txabqfC56b6Y5w75WlWqdOGAClU32s7ZSEmn6lTD4NjxaD9ms3GrQ2EAtaOokLhx_hS43daVTG3nomngJFRPFReJ_9emnQait4LeCkfW36KsyfY3tLgr_BlMcmDXae-7vZcLuRBZ4gY3zGRXMzFm1AS18Aiq45T7NX1jsSugiwaFqdH2blznzpImXPe-MbFc_QLwWu6lHNaDU-5xEDynkn-8FdtmLUJWCLT_O-h6POdYvw9wUCTovNFCbl_WWdyZEp4lqavSQN_xdGRmpzJNfDZjMWrBxIgBOdbTTyI1kyJgMkGP3vk0n9ibQH5ka2e_zg9OScaVW0xmNxgWzYIJHiRA6AI0IT3AR-oqNVGaPC6IF34c-X4HstvR4yF7TSDwf47EPFOIwVZgmrq0uCuLz_Kibx5j2vht590USHUF-7ioDyXzDcRChWdYDTHCGEqGb_HUHbLv_Xaw_0If9FZCQXc7dMgsttqqo_b49kx828tVop-gDdrXrUErhTpMn_NvOJC6kYNtNwyVnFrC7ExhhaWQ6_LZl7JQyt1Bf_vLck06wCXNZQazths1Uri7NZm_GGAahXXH5duMNK-CggSnQd9WeQoQI98Cs1DuUgQl-MeC9PJZ9t3p1M4OSt38f3e0oZ0ywnmFc58nzWgXogEgAHdtdzFx6mhqk37fHBi0kG75pYwogBkj8eXDhWQm4XmowaRyHopCCNcHePG2LbrZwsDzKdPOiWOOQWuoR4yhjoGxjOQaOKCTBMVpMM_4xgLQ1EASZzf9ibpS8dMnynIgkfIV18yqVMUYmNE97-lVYAcZn2RoO0d6t9M2v0u-a8AmL_9b6mDgIzKppWgh6UALRlnjwUt2r98gSIL61grtD-XY4FgmpFYHFTEqtjg_vj45bo5ixu8c_z9R-Lm6b5JxzNZldDlUh4FoWzWe_IA5ox3cmLt_hyze3v1AiIz2-9Yv2X7FgzdvTiZNRCkfn74-_Lg1zc3Pk9oxSk0mqmVaLr2VFi0SwFW2UurL5kltq_YD3EB6Ja1TVnWWQKPihTDQgNW0J-pM0gx9t11yAOsBS_7NeVSak_zfu0Ed2loJ-q1sTppybyQYBoig5IUTvvV3DDh7RdyWTI3MOsk-DwdP-mycWPmFMWCQ-uAc5Iu67cJMlrG3A_fPUiTkTEhjDsB5Yl0f9k8YkauLeEIsAzAaoJ_cIa4ZCv7E7fC0qtTUifpDTUIXYQpyo6PJ5IE2yg7Y49lQdQbcYvYavycKXybHJV_LPhu57FkdJC_rX6wIIsevPoHrxGLrbCUyorNJfGqfo3qfkv26DW17EGLx-5Xcmlqt84jwnaWKx8lAQWhod_i157m7VgLtKB7IArdrieJw428o9xgTcN4ngIbK6KgHhCag1AIqEIpdDN221hvRLFlWVpFp0iISdq6biVrOCAYMtyBHMISzSjBHEaDrXytoshgUTX0AD0cZBchDHkxvUVSjtIgm6sn-n7qFQjQbBM2WIT5n3wAfTy3JDJOTx9rrtL319Q-ARlQuDoVkcJHVO3ficUSr-foGWm0ZmaduachZzJikHRzqA_wXs09_9rVrCIiCY6tz56yKBiz9ImwL4IOq4D8r5APiHqi4mWopHaVnR9-n-PFUYYjzsRitxqxOX_11BLic13PUt0-_my6cg1m_y8720eJ17WmqeVRrP-VgmhJwPgV0WuMXnaIkI1_HZjZk4dXTMUecUFZowXKt-HvDeBOBnRKAqzGjOlx7UFqihfEp1_41Wre8HMio7_E",
        ListSelectedOpuIds: "d68ddde9-d8ab-4840-8d0c-fea8a56fa057",
      };

      const locations = await Axios.get(
        `${API.uaucUrl()}/api/api/v1/mdLocations/GetLocationTreeAsyncByEnterpriseAndRecordId?includeInactive=false`,
        { headers: headers }
      );
      this.locations = locations.data.children[0].children;
    },
    async getActivies() {
      const headers = {
        Accept: "application/json, text/plain, */*",
        "Accept-Language": "en-US,en;q=0.9,vi;q=0.8,id;q=0.7",
        Authorization:
          "Bearer JSb1aZxyxKpqq_rEgcIbGvjHnmRDD7VOcFncYFP5zGGZFHAfTwOdG9LWA0EezUoAaUp5P1bBn-AHcSS0cgm-oWP5M-1RB2bsO0C8r9oy68QsFh_nr1d2C7sM6c8a5bhxr0NWkmbPzJXdKdbUOZLOcxEkF6ZyBgVO3hleA4Oid4n-f8-SidkLRC-dBHCGXfVeZ-okWioX4_Fc0zvv-q300ISHZar_vzhN4h9_ZP2W2x4Qy4bb5n-tMY_Y0MybVr29t9UZycPG-WYKTmHCgEVEdh4-DpjaXlC5QmNmb7YV0siP9d9BOht180-MhkiI9MQmOv8aSG_ECOxSAaGVkY7rtE6vuQtEtyvMJT6B8qGQ_AzUN717IWZ7vcgiwxVoPHIL-6Yd2cv1_j7IYvh_Ux1y581poSSLW58fsOv94gM-wvKeqp37WPIb_rr5yrQch5AGUmnFS--W4enC-a-r40N5ig72VhkZskk6Eerjk-EM74_-GBSFXNL5p8CX-ZIGRS20BamkTLKEaIIKG7OvbiLTbaxKrNuaWKTybReBohbIV4nHjTJRE_JkMj1gB88T5_NgmZNUSk9eqE-p46ayxYeDKYHuYn0AE4jNla5Ldykp11ZQTOZ3sXKS8PMu4bKtZYG7xoFul7z5yXULeAu-6uB4Yp2KGHViw50Fi6jMMN_yZJ08E1HzQWBeawTifpxO2dVJB-A3vBO19_svjoy3Vb-CqyHPyZXNTwBMy7Rt4uKQqYekXIFgXFAaPlFHFSCIETHuB5qI1NU0erFnJnvgeQatvhuqTlI4dkTPUgUoFpkxQQhGqIhuD12IdztItrPrpL05YwMHnpU3aQ3toUuwIvq2Vz0F2vVwtNfi2SKrp-IktJ2F1-1238i0eeYZ3GIVhoVhvBA1k8vP4r7wCW-QfOYunJFr15XUzol4Js5oRu0TmkXOxlVu7oOFqAHLEg-nkfudWbGmgtthaElxEQ88hGwTnAB-9TahnmmOdLZ4b5qcYlwCMdh7qQFR4v717VZ0cSBPItcej2vbP1z2RjdmF0iYicv9Xhe0fifiydsj84vLXlUBQf9fOciBNLLuy77JaAR0Ba7z-_etM0lSNWqHkNy7S8oNjnEk7okFVxLYQLPpglInQGZOid4qv_9XCqFRPqo5CmNbmmn4F9-EiX6EP49p8kGK9uzuje6PkdCy-tlTtHr-7ABp8TEBzo9CSqseqwhDdXoOYtWniKqWUQCzwWY11KiJgkq6BUW59taXQo_Jqs_zoTElm8Fej40pUVaeM7lNh5pOxuI2CVxobFMPbD6lxP7G6-xGQASq3JXWZi1GZQcfvm9s38-WR7deRcJPtjkwZPoNFj1QDc7Zd1Cx4lbwR6KQBTsAPjXAuPUZQJPv4L5qx4wp_KZZsS0C3gWk8kdzHyoAtm7VhIfoQaRrGeF7I22bae-A8cF4tfC3G_zrjSlWoJWM7Zn-DlXMo-vVNnmytIjnGTR7WyMaWg0SzwO26S-8HG1FCxD7cb5_-oVCPXtmOklhcVGiAPleeyB54HmcDPyt5LyZ6Yk-mGwdnP0_R8ATJeeKirT5X6V9oiJW6BrC33M1xW8rESwyOcFWuTCCrToc5qANz49a8pFN8gWbvm7WzKz3TqZnnDW_gaXvzRDpiKaeR2yuOIYTgjvipaPKGEqSdmBr4PviV90F_eAsSLgFuvv-6a0yfPMT-Qs9MXf-YBetY1BUPRTdxhF9JwJEu7MNPClCYhsa6OUt7jQmIFDOJWOleGd73bW9T5BOwD9jU6WmmpZzVDNdxSkJ_8pSCRKjk1ctWrNUDepCFWXpNBEyN7Q7Xet8QLaqxz_g4FsNf7XCMKE4axh2yGkNuwNm4rXX193nfLzTlBDWzCzHXIjmiE4vHRH8rgEiSXh5xLoVHLnWKpKamTTgI17bXH518q-10OY0SkvUvXyOslk87piqQ9rxo_oO1cdi6B9JqfGnHRglwUfJMbJbAkyg4aOMxPEdrsMQqimliSl__gjDBJrQetbHg4qMMfxV9ZyaWDhAzLnwUUg_BDI4E8HJYIC_ckw6dTFv3DtITz9qIDadl6WTokX_kZpto_XLjxe-t2RtpJs4BZ0XolIHs7eIrJKKn77zWxMJ7chz1ZhXrQyEkESmULcUz5AaBEpDlKuy1sITp00oJPkwPV6HnBNFvxNzjb_V0kwtIUKYNKdT0FA4jTPZB6Vms34lI6t2XCeTO6QFH5vEIrXN9u2mnEFEZBWSDLcMUwmK8USbqpYrHUAV2LXs5PAWtK6bWyAEb-XzasJqh8WsCd34xDQaI49RfzUeF3dNOx5kHLC_dUC1fviSxUKu7he2UFfkRm5JidtNkI640p_qmPhr-c8C0anLF2H_MsFXXldDabVwF4_0zeCF_v4cSRQfWUtTnbFh79W0kp_h6TXHc4Xo_awUwyL2X9FDTdZ9evbiQxuCmbd4l5sKUmp12F_gIG_lWbxc87fLf-1eHNShH4TL3_uk85plUZNywqT1-PERW9aJCWHaumsfozJNAY4dEec4SsWoiN85XSAJ7LSFdz7qoYimaV4nuueqHK5-3WPJs4gd3mgsN3heIsx-i47_ckHjAgC9a4A7y9RPIPnawtfex4l8HbrMsy69t8cxWyeAz8rubly6h5fZKZWBEAsPrXs4ZBqh5440zdaCoVd5hWfqzUVkQFgO7IjaYCt8rjQZtfEhmrNIL9b9K2chhYJaoPQFyffImuxikzYVTfK06qWpMTgln-Isfo9YJhNpDIRCeD2NonzncjWa5_SODxmp293DrpZJImNAvYfTUaMcHbLCsaAmD5jKw7CJoMNY5fMr_4v6QufAVk9DAEXGSgPmlOHZFVhaNw6EioyqvPeQi4GcBvnLMDHNvELo7MCYiQTohVsWh99Xo0iD_8ABx-jZDbR2AZXyOAAkzvAL23XdrcMswzw7fDtgGdVzPK_JQ3BYDRelrc_8htkAcqup-FtTy9rE_KFi7MybH_IjEEGLofvsahV7uAVTijJIuVUNMTuk9CE89ILqSKeeIbADLUERMwlsoO-z5jHYkyLDh2t3gl_1Ufaj5degAL4VKVDhX2woOfH4L9V9csvLACSb9RdnaWbjEd8aWHHjRG0MsqW4i1zh3-PwMaDyFVsSyZxogJM_6mxRFsBthtWFJrowsjwAPPOGK0_RQvwRWFk6gUyj5kCezhj-ixnv1rcZziGCqQaG02waJLlO1WR5m7S5m3_g6Xl1dudnYpEml-0OEjRxAuUJ5-lLPKQCo2dAEjFJZUNgnqfcXUJeKKkJ-_siWqx1L0WuWJT7r8cRZsCT_LHu65wtc10Lm42wspMulygJCNlCPimKMzcuI_9iuy5RhawuKhVpdm-YAu0jXMBDLonhwdQ7ea3fTSxHypMTPQbf4ZO2GonxHCyhoZDSFdOeIQ02nV7t4yZLok9PGfuf6I13A6w163jTw4mRkfhOl-nrpP1CgHJwhiXI4iFMRQHyQhTbZazwDgalmPpMzvzTVIHCL9gpoUR_SNJehKxDSGzdiUIFmN3_7pKDTZtrDtDxuhNp4TGKg6Nq10JxWRAnRL6YUdu3kDGyhUgd-YSVszUmhzLHazvaq49fXWUQDTUeXC9FW873O5DtRF9_GnEptIKjmkAGdwO1-l3qRE4LH-RfsXhm4OFuupO6Nt1v9rPmZ0AUMcbp05YzMYCspD9LCMGRvubxFdXnug6rePbfJkM-W9eEe183AtXt9NevtQde60hBCKpukzgSVYBDiwnOgRYKxLg9txabqfC56b6Y5w75WlWqdOGAClU32s7ZSEmn6lTD4NjxaD9ms3GrQ2EAtaOokLhx_hS43daVTG3nomngJFRPFReJ_9emnQait4LeCkfW36KsyfY3tLgr_BlMcmDXae-7vZcLuRBZ4gY3zGRXMzFm1AS18Aiq45T7NX1jsSugiwaFqdH2blznzpImXPe-MbFc_QLwWu6lHNaDU-5xEDynkn-8FdtmLUJWCLT_O-h6POdYvw9wUCTovNFCbl_WWdyZEp4lqavSQN_xdGRmpzJNfDZjMWrBxIgBOdbTTyI1kyJgMkGP3vk0n9ibQH5ka2e_zg9OScaVW0xmNxgWzYIJHiRA6AI0IT3AR-oqNVGaPC6IF34c-X4HstvR4yF7TSDwf47EPFOIwVZgmrq0uCuLz_Kibx5j2vht590USHUF-7ioDyXzDcRChWdYDTHCGEqGb_HUHbLv_Xaw_0If9FZCQXc7dMgsttqqo_b49kx828tVop-gDdrXrUErhTpMn_NvOJC6kYNtNwyVnFrC7ExhhaWQ6_LZl7JQyt1Bf_vLck06wCXNZQazths1Uri7NZm_GGAahXXH5duMNK-CggSnQd9WeQoQI98Cs1DuUgQl-MeC9PJZ9t3p1M4OSt38f3e0oZ0ywnmFc58nzWgXogEgAHdtdzFx6mhqk37fHBi0kG75pYwogBkj8eXDhWQm4XmowaRyHopCCNcHePG2LbrZwsDzKdPOiWOOQWuoR4yhjoGxjOQaOKCTBMVpMM_4xgLQ1EASZzf9ibpS8dMnynIgkfIV18yqVMUYmNE97-lVYAcZn2RoO0d6t9M2v0u-a8AmL_9b6mDgIzKppWgh6UALRlnjwUt2r98gSIL61grtD-XY4FgmpFYHFTEqtjg_vj45bo5ixu8c_z9R-Lm6b5JxzNZldDlUh4FoWzWe_IA5ox3cmLt_hyze3v1AiIz2-9Yv2X7FgzdvTiZNRCkfn74-_Lg1zc3Pk9oxSk0mqmVaLr2VFi0SwFW2UurL5kltq_YD3EB6Ja1TVnWWQKPihTDQgNW0J-pM0gx9t11yAOsBS_7NeVSak_zfu0Ed2loJ-q1sTppybyQYBoig5IUTvvV3DDh7RdyWTI3MOsk-DwdP-mycWPmFMWCQ-uAc5Iu67cJMlrG3A_fPUiTkTEhjDsB5Yl0f9k8YkauLeEIsAzAaoJ_cIa4ZCv7E7fC0qtTUifpDTUIXYQpyo6PJ5IE2yg7Y49lQdQbcYvYavycKXybHJV_LPhu57FkdJC_rX6wIIsevPoHrxGLrbCUyorNJfGqfo3qfkv26DW17EGLx-5Xcmlqt84jwnaWKx8lAQWhod_i157m7VgLtKB7IArdrieJw428o9xgTcN4ngIbK6KgHhCag1AIqEIpdDN221hvRLFlWVpFp0iISdq6biVrOCAYMtyBHMISzSjBHEaDrXytoshgUTX0AD0cZBchDHkxvUVSjtIgm6sn-n7qFQjQbBM2WIT5n3wAfTy3JDJOTx9rrtL319Q-ARlQuDoVkcJHVO3ficUSr-foGWm0ZmaduachZzJikHRzqA_wXs09_9rVrCIiCY6tz56yKBiz9ImwL4IOq4D8r5APiHqi4mWopHaVnR9-n-PFUYYjzsRitxqxOX_11BLic13PUt0-_my6cg1m_y8720eJ17WmqeVRrP-VgmhJwPgV0WuMXnaIkI1_HZjZk4dXTMUecUFZowXKt-HvDeBOBnRKAqzGjOlx7UFqihfEp1_41Wre8HMio7_E",
        ListSelectedOpuIds: "d68ddde9-d8ab-4840-8d0c-fea8a56fa057",
      };

      let url = `${API.uaucUrl()}/api/api/v1/dropDownList/getAllActivity/90c1e813-6a09-4753-9c43-2c84af34eee7`;

      const activities = await Axios.get(url, { headers: headers });
      this.activities = activities.data;
    },
    saveCurrentLocation() {
      this.isSavingModel = false;
      API.put(`cameras/${this.camera.id}`, {
        data: {
          current_location: this.model.currentLocation.name,
          current_location_id: this.model.currentLocation.id,
        },
      })
        .then((retVal) => {
          this.camera.current_location = this.model.currentLocation;
        })
        .finally(() => {
          this.isEditingLocation = false;

          this.isSavingModel = false;
        });
    },
    saveCurrentActivity() {
      this.isSavingModel = false;

      API.put(`cameras/${this.camera.id}`, {
        data: {
          currentActivity: this.model.currentActivity.name,
          currentActivityId: this.model.currentActivity.id,
        },
      })
        .then((retVal) => {
          this.camera.currentActivity = this.model.currentActivity.name;
        })
        .finally(() => {
          this.isEditingActivity = false;

          this.isSavingModel = false;
        });
    },
    toggleShrinkDetectionType() {
      const elem = $("#detection-settings");

      if (elem) {
        elem.scrollTop(0);
      }

      this.resetDetections();

      this.shrinkDetectionType = !this.shrinkDetectionType;
    },
    saveDetections() {
      this.isSavingModel = true;

      API.put(`cameras/${this.camera.id}`, {
        data: {
          detections: this.model.detections,
        },
      })
        .then((retVal) => {
          this.camera.detections = this.allDetections.filter((ad) =>
            this.model.detections.includes(ad.id)
          );
        })
        .finally(() => {
          this.isSavingModel = false;
        });
    },
    resetDetections() {
      this.model.detections = JSON.parse(
        JSON.stringify(this.camera.detections)
      ).map((d) => d.id);
    },
    cameraIsOffline() {
      this.$set(this.camera, "isError", true);
    },
    goBack() {
      if (this.camera && this.camera.type == "lab") {
        this.$router.push({
          name: "Lab",
        });
      } else if (this.camera && this.camera.type == "cctv") {
        this.$router.push({
          name: "CCTV",
        });
      } else if (this.camera && this.camera.type == "aisc") {
        this.$router.push({
          name: "AISC",
        });
      }
    },
    formatDate(date) {
      return Moment(date).format("DD/MM/YYYY h:mm A");
    },
    viewEvent(event) {
      this.currentEvent = event;
    },
    cctvSrc(cctv) {
      if (cctv.name.toLowerCase().includes("aisc_uauc")) {
        const uaucNameArray = cctv.name.split("_");

        return uaucNameArray.length == 2
          ? "https://uauc.inference.asia"
          : `https://uauc${
              uaucNameArray[uaucNameArray.length - 1]
            }.inference.asia`;
      } else {
        return `${this.apiHost(cctv.serverNum)}:${cctv.broadcastPort}`;
      }
    },
    apiHost(serverNum) {
      if (serverNum && serverNum == 2) {
        return API.apiHostServer2();
      } else {
        return API.apiHostServer1();
      }
    },
    setLiveView() {
      if (this.camera) {
        this.currentEvent = {
          id: "live",
          image: {
            url: this.cctvSrc(this.camera),
          },
        };
      }
    },
    async getAllCameras() {
      await API.get("cameras?fields=id,name,type&sort=type")
        .then((retVal) => {
          this.allCameras = [];

          retVal.data.forEach((element) => {
            let ac = this.allCameras.find((c) => c.type == element.type);

            if (ac) {
              ac.cameras.push(element);
            } else {
              this.allCameras.push({
                type: element.type,
                cameras: [element],
              });
            }
          });

          this.allCameras.map((ac) => {
            ac.cameras.sort((a, b) => {
              return a.id - b.id;
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getAllDetections() {
      await API.get("detections?sort=displayName")
        .then((retVal) => {
          this.allDetections = retVal.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCamera() {
      this.isLoading = true;

      API.get(`cameras/${this.$route.params.cameraId}?populate=detections`)
        .then((retVal) => {
          this.camera = Object.assign(
            { id: retVal.data.id },
            retVal.data.attributes
          );

          if (this.camera.detections) {
            this.camera.detections = this.camera.detections.data;

            this.model.detections = JSON.parse(
              JSON.stringify(this.camera.detections)
            ).map((d) => d.id);
          }

          if (this.camera.current_location) {
            this.model.currentLocation = this.camera.current_location;
          } else {
            this.model.currentLocation = null;
          }

          if (this.camera.currentActivity) {
            this.model.currentActivity = this.camera.currentActivity;
          } else {
            this.model.currentActivity = null;
          }

          this.getEvents();
        })
        .catch((err) => {
          console.error(err);

          this.isLoading = false;
        });
    },
    getEvents(id) {
      this.setLiveView();

      let endpoint = this.camera.type == "cctv" ? "events" : "violations";

      if (id) {
        endpoint += `/${id}`;
      }

      const defaultQuery = `?populate=camera,image,annotatedImage&sort=timestamp:DESC&filters[camera][id][$eq]=${this.camera.id}`;

      endpoint += defaultQuery;

      let startDate, endDate;

      if (this.filter.date) {
        startDate = Moment(this.filter.date).startOf("day").toISOString();
        endDate = Moment(this.filter.date).endOf("day").toISOString();
      } else {
        startDate = Moment().startOf("day").toISOString();
        endDate = Moment().endOf("day").toISOString();
      }

      endpoint += `&filters[timestamp][$gte]=${startDate}&filters[timestamp][$lte]=${endDate}`;

      API.get(`${endpoint}`)
        .then((retVal) => {
          let retValData;

          if (id) {
            let raw = JSON.parse(JSON.stringify(retVal.data));

            Object.keys(retVal.data.attributes).forEach((key) => {
              if (key != "camera" || key != "image")
                raw[key] = retVal.data.attributes[key];
            });

            if (retVal.data.attributes.camera) {
              raw.camera = Object.assign(
                retVal.data.attributes.camera.data.attributes,
                {
                  id: retVal.data.attributes.camera.data.id,
                }
              );
            }

            if (
              retVal.data.attributes.image &&
              retVal.data.attributes.image.data &&
              retVal.data.attributes.image.data.length > 0
            ) {
              raw.image = Object.assign(
                retVal.data.attributes.image.data[0].attributes,
                {
                  id: retVal.data.attributes.image.data[0].id,
                }
              );
            }

            retValData = raw;
          } else {
            retValData = retVal.data.map((r) => {
              r.camera = Object.assign(r.camera.data.attributes, {
                id: r.camera.data.id,
              });

              if (r.image && r.image.data && r.image.data.length > 0) {
                r.image = Object.assign(r.image.data[0].attributes, {
                  id: r.image.data[0].id,
                });
              }

              return r;
            });
          }

          if (id && retValData && !this.events.find((ev) => ev.id == id)) {
            this.events.unshift(retValData);
          } else {
            this.events = retValData;
          }

          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);

          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control:disabled {
  background-color: #acacac;
  font-weight: 600;
  border: none;
  cursor: not-allowed;
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #acacac;
  border-color: #d1dbe5;
}
</style>